import { useMemo } from 'react';
import { handleDatas } from '../utils/common';

// 用于Headcounts/Headcount Cost/5Y Headcounts模块处理接口数据
function useHeadcountsList(props: {
  loading: boolean,
  responseRes: any,
  module?: string,
}) {
  const {
    loading,
    responseRes,
    module,
  } = props;

  // const orgData: orgHeadcountsDataTypes = useMemo(() => {
  //   const data = responseRes?.data?.data;
  //   if (loading || !Array.isArray(data) || !data?.length) return null;
  //   try {
  //     const metrics: string[] = [],
  //           dataList: { [key: string]: string }[] = [];
  //     for (let index = 0; index < data?.length; index++) {
  //       const item = data?.[index];
  //       const metricList: { [key: string]: string } = {};
  //       for (let i = 0; i < item?.metrics_info?.length; i++) {
  //         const t: { name: string; value: string } = item?.metrics_info?.[i];
  //         metricList[t.name] = t?.value;
  //         metrics.includes(t.name) || metrics.push(t.name);
  //       }
  //       dataList.push({
  //         date: item.date,
  //         ...metricList,
  //       });
  //     }
  //     // 把Others固定排在最后
  //     if (metrics.includes('Others')) {
  //       const index = metrics.indexOf('Others');
  //       metrics.splice(index, 1);
  //       metrics.push('Others');
  //     }

  //     return {
  //       isSuccessReq: (responseRes?.status === 200) && (responseRes?.data?.code === 200),
  //       metrics,
  //       dataList,
  //     };
  //   } catch (error) {
  //     console.error(error);
  //     return null;
  //   }
  // }, [loading]);

  // 将数据处理逻辑 原封不动搬到 handleDatas 方法里了，handleDatas方法在PDF下载中 也有复用
  const orgData: orgHeadcountsDataTypes = useMemo(() => {
    if (loading) return null;
    return handleDatas(responseRes, module);
  }, [loading]);

  return {
    orgData,
  };
}

export default useHeadcountsList;
